/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ done: NonNullable<unknown>, total: NonNullable<unknown> }} Idea_Attach_UploadingInputs */

const en_idea_attach_uploading = /** @type {(inputs: Idea_Attach_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Uploading ${i?.done}/${i?.total}…`)
};

const id_idea_attach_uploading = /** @type {(inputs: Idea_Attach_UploadingInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mengunggah ${i?.done}/${i?.total}…`)
};

/**
* | output |
* | --- |
* | "Uploading {done}/{total}…" |
*
* @param {Idea_Attach_UploadingInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const idea_attach_uploading = /** @type {((inputs: Idea_Attach_UploadingInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Idea_Attach_UploadingInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_idea_attach_uploading(inputs)
	return en_idea_attach_uploading(inputs)
});